export {FollowCompanyButtonValidator as FollowCompanyButton} from './validator';
